import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import Button from '../../../../components/formControls/Button';
import FormSectionTitle from '../../../../components/FormSectionTitle';
import Input from '../../../../components/formControls/Input';
import ToastMessage from '../../../../components/messages/ToastMessage';
import Select2 from '../../../../components/formControls/Select2';
import { saveVirtualOperatorNoCreditRuleRequest } from '../../../../js/virtualOperator/actions';
import Label from '../../../../components/formControls/Label';
import { FormGroup } from 'reactstrap';
import { PhoneRulesEnums } from '../../../../js/phoneRules/PhoneRulesUtils';
import { getPbxArchivedGreetingMessages } from '../../../../js/vbox/selectors';
import PlayPauseAudioButton from '../../../../components/PlayPauseAudioButton';
import ynConf from '../../../../conf';
import { getVirtualOperatorNoCreditRule } from '../../../../js/me/selectors';
import FormFieldError from '../../../../components/messages/FormFieldError';
import { fetchArchivedGreetingMessagesRequest } from '../../../../js/vbox/actions';
import { isSaveNoCreditRuleError, isSaveNoCreditRuleLoaded, isSaveNoCreditRuleSuccess } from '../../../../js/virtualOperator/selectors';

const messages = defineMessages({
  title: {
    id: 'PbxVirtualOperatorSettingsNoCredit.title',
    defaultMessage: 'Rule with no credit',
  },
  info: {
    id: 'PbxVirtualOperatorSettingsNoCredit.info',
    defaultMessage: 'Rule that will be enabled on route towards virtual operator when you have no more money',
  },
  actionCf: {
    id: 'PbxVirtualOperatorSettingsNoCredit.label.actionCf',
    defaultMessage: 'Forwarding',
  },
  actionRe: {
    id: 'PbxVirtualOperatorSettingsNoCredit.label.actionRe',
    defaultMessage: 'Responder',
  },
  audioMessage: {
    id: 'PbxVirtualOperatorSettingsNoCredit.label.audioMessage',
    defaultMessage: 'Audio message',
  },
  forwardTo: {
    id: 'PbxVirtualOperatorSettingsNoCredit.label.forwardTo',
    defaultMessage: 'Forward to',
  },
  errorNoAction: {
    id: 'PbxVirtualOperatorSettingsNoCredit.error.noAction',
    defaultMessage: 'Please select an action',
  },
  errorNoGreeting: {
    id: 'PbxVirtualOperatorSettingsNoCredit.error.noGreeting',
    defaultMessage: 'Please select a greeting message',
  },
  errorNoForwardTo: {
    id: 'PbxVirtualOperatorSettingsNoCredit.error.noForwardTo',
    defaultMessage: 'Please select a forward destination',
  },
  buttonSave: {
    id: 'PbxVirtualOperatorSettingsNoCredit.button.save',
    defaultMessage: 'Save',
  },
  saveError: {
    id: 'PbxVirtualOperatorSettingsNoCredit.saveError',
    defaultMessage: 'Saving error',
  },
  saveSuccess: {
    id: 'PbxVirtualOperatorSettingsNoCredit.saveSuccess',
    defaultMessage: 'Saving successfully performed',
  },
});

class PbxVirtualOperatorSettingsNoCredit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      action: this.props.rule ? this.props.rule.action : null,
      greeting: this.props.rule ? this.props.rule.greeting : null,
      forward: this.props.rule ? this.props.rule.forward : null,
      errors: {},
    };
  }

  componentDidMount() {
    this.props.fetchAudioMessages();
  }

  onChangeAction = (e) => {
    this.setState({ action: e.target.value, errors: {} });
  };

  onChangeAudioMessage = (selectedOption) => {
    this.setState({ greeting: selectedOption ? selectedOption.value : null, errors: {} });
  };

  onChangeForward = (e) => {
    this.setState({ forward: e.target.value, errors: {} });
  }

  onSubmit = () => {
    const { action, greeting, forward } = this.state;
    if (!action) {
      this.setState({
        errors: {
          action: this.props.intl.formatMessage(messages.errorNoAction),
        },
      });
      return;
    }
    if (action === PhoneRulesEnums.SettingsActions.responder && !greeting) {
      this.setState({
        errors: {
          greetingMessage: this.props.intl.formatMessage(messages.errorNoGreeting)
        },
      });
      return;
    }
    if (action === PhoneRulesEnums.SettingsActions.forward && !forward) {
      this.setState({
        errors: {
          forwardTo: this.props.intl.formatMessage(messages.errorNoForwardTo)
        },
      });
      return;
    }
    this.props.save({
      action,
      greeting: action === PhoneRulesEnums.SettingsActions.responder ? greeting : null,
      forward: action === PhoneRulesEnums.SettingsActions.forward ? forward : null,
    });
  }

  render() {
    const {
      audioMessages,
      saving,
      savingError,
      savingSuccess,
      intl: { formatMessage },
    } = this.props;

    const optionsAudioMessages = audioMessages.map((m) => ({
      label: m.filename,
      value: m.id,
    }));

    const fileToPlay =
      audioMessages.filter((m) => m.id === this.state.greeting).length > 0
        ? audioMessages.filter((m) => m.id === this.state.greeting)[0].file
        : null;

    const selectedAudioMessage = optionsAudioMessages.filter(
      (o) => o.value === this.state.greeting
    );

    return (
      <>
        <FormSectionTitle className="mt-3 mb-1">
          {formatMessage(messages.title)}
        </FormSectionTitle>
        {savingError && (
          <ToastMessage
            type="danger"
            text={formatMessage(messages.saveError)}
            messageCode={savingError}
          />
        )}
        {savingSuccess && (
          <ToastMessage
            type="success"
            text={formatMessage(messages.saveSuccess)}
            messageCode={savingSuccess}
          />
        )}
        <div className="font-weight-light p-1 pb-3">
          {formatMessage(messages.info)}
        </div>
        <div className="row px-3">
          <div className="col-xl-4 col-md-6 col-sm-4">
            <FormGroup>
              <div className="custom-control custom-radio custom-control-inline mr-1">
                <input
                  type="radio"
                  id="action_re"
                  onChange={this.onChangeAction}
                  checked={
                    this.state.action === PhoneRulesEnums.SettingsActions.responder
                  }
                  name="action"
                  value={PhoneRulesEnums.SettingsActions.responder}
                  className="custom-control-input"
                />
                <label className="custom-control-label" htmlFor="action_re">
                  {formatMessage(messages.actionRe)}
                </label>
              </div>
            </FormGroup>
          </div>
          <div className="col-xl-4 col-md-6 col-sm-4">
            <FormGroup>
              <div className="custom-control custom-radio custom-control-inline mr-1">
                <input
                  type="radio"
                  id="action_cf"
                  onChange={this.onChangeAction}
                  checked={this.state.action === PhoneRulesEnums.SettingsActions.forward}
                  name="action"
                  value={PhoneRulesEnums.SettingsActions.forward}
                  className="custom-control-input"
                />
                <label className="custom-control-label" htmlFor="action_cf">
                  {formatMessage(messages.actionCf)}
                </label>
              </div>
            </FormGroup>
          </div>
        </div>
        {this.state.errors.action && (
          <FormFieldError text={this.state.errors.action} style={{ display: 'block' }} />
        )}
        {(this.state.action === PhoneRulesEnums.SettingsActions.vbox ||
            this.state.action === PhoneRulesEnums.SettingsActions.responder) && (
              <>
                <Label for="audioMessage" mandatory>
                  {formatMessage(messages.audioMessage)}
                </Label>
                <div className="form-row">
                  <div className="col-xl-8">
                    <FormGroup>
                      <Select2
                        id="audioMessage"
                        name="audioMessage"
                        isClearable
                        value={selectedAudioMessage}
                        onChange={this.onChangeAudioMessage}
                        options={optionsAudioMessages}
                        error={this.state.errors.greetingMessage}
                      />
                    </FormGroup>
                  </div>
                  <div className="col-xl-1 mt-2">
                    {fileToPlay && (
                      <PlayPauseAudioButton
                        filename={`${ynConf.fileBaseUrl}/vbox/greeting-switchboard/download/${fileToPlay}`}
                      />
                    )}
                  </div>
                </div>
              </>
            )}
          {this.state.action === PhoneRulesEnums.SettingsActions.forward && (
            <div className="form-row px-2">
              <div className="col-xl-4 col-sm-6">
                <FormGroup>
                  <Label for="forwardTo" mandatory>
                    {formatMessage(messages.forwardTo)}
                  </Label>
                  <Input
                    type="text"
                    onChange={this.onChangeForward}
                    value={this.state.forward}
                    name="forwardTo"
                    id="forwardTo"
                    error={this.state.errors.forwardTo}
                  />
                </FormGroup>
              </div>
            </div>
          )}
        <div className="pt-3 text-center">
          <Button
            className="btn btn-primary"
            loading={saving}
            text={formatMessage(messages.buttonSave)}
            onClick={this.onSubmit}
          />
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    audioMessages: getPbxArchivedGreetingMessages(state),
    saving: !isSaveNoCreditRuleLoaded(state),
    savingError: isSaveNoCreditRuleError(state),
    savingSuccess: isSaveNoCreditRuleSuccess(state),
    rule: getVirtualOperatorNoCreditRule(state),
  };
}

export default injectIntl(
  connect(mapStateToProps, {
    fetchAudioMessages: fetchArchivedGreetingMessagesRequest,
    save: saveVirtualOperatorNoCreditRuleRequest,
  })(PbxVirtualOperatorSettingsNoCredit)
);
